<template>
	<BaseCenteredMessage>
		<template #icon><BaseIcon name="mono/warn" class="w-40 h-40 text-red-500" /></template>
		<template #title>Page Not Found</template>
		<template #details>
			<p>It may have been moved, deleted or the url is incorrect.</p>
		</template>
		<template v-if="$auth.isAuthenticated.value" #actions>
			<RouterLink v-if="!$store.isExtension" to="/" class="button-green"> Back to my account </RouterLink>
			<a v-else :href="$env.VUE_APP_URL" class="button-green">Back to my account</a>
		</template>
		<template v-else-if="!$auth.loading" #actions>
			<a :href="$env.VUE_APP_URL" class="button-green">Log in</a>
		</template>
	</BaseCenteredMessage>
</template>
